export enum OdontoGuideServicesTypeEnum {
	EMERGENCY = 'PRONTO SOCORRO 24 HRS URGEN/EMERGEN',
	OUTPATIENT = 'CONSULTORIOS/CLINICAS',
}
